@if (featureSet) {
  <div class="container-fluid">
    <div class="row justify-content-start">
      <div class="col-md-8 col-xs-12">
        <div class="mt-3" name="timeSpan" aria-label="Time Span">
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly" (click)="changeTimeSpan('weekly')">Weekly</mat-button-toggle>
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly" (click)="changeTimeSpan('monthly')">Monthly</mat-button-toggle>
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom" (click)="changeTimeSpan('custom')">Custom</mat-button-toggle>
        </div>
        @if (!hasNoData) {
          <lds-feature-list [timespan]="timespan" [startTime]="startTime" [endTime]="endTime" [features]="features" [data]="daily_data" [productCode]="featureSet.productCode"  [deviceType]="deviceType"></lds-feature-list>
        }
        @if (hasNoData) {
          <p>No Data</p>
        }
        @if (!hasNoData) {
          <div class="left-graph-container">
            @if (daily_data) {
              <lds-y3-graph [startTime]="startTime" [endTime]="endTime" [timespan]="timespan" [data]="daily_data" [features]="features" [deviceType]="deviceType" [featureSet]="featureSet"></lds-y3-graph>
            }
            <!-- <app-graph [data]= "switchData" [features]= "switchFeatures" graphName = "device-detail" *ngIf="show"></app-graph> -->
            <!-- <app-graph [data]= "recentActivity" graphName = "recentActivity" *ngIf="recentActivity"></app-graph> -->
            <div class="below-graph">
              <button class="lds-btn" (click)="onExportClick()">Export Data</button>
            </div>
            <div class="below-graph-text">
              <p>Click and drag to zoom.</p>
            </div>
          </div>
        }
      </div>
      <div class="pl-md-0 col-md-4 pt-md-4 pt-3 col-xs-12 mb-2">
        <div class="info-container py-2 text-center mb-2">
          <div class="icon">
            <i class="{{ icons.getIcon(featureSet.productCode) }}" [style.margin-left]="this.icon_margin"></i>
          </div>
          <div class="productcode-box">
            {{displayProductCode(featureSet.productCode)}}
          </div>
        </div>
        @if (!hasNoData) {
          <div class="mx-2 mx-md-0">
            <!-- <div class="pie-chart-container pt-2 mb-2">
            <div class="mx-4">Eco7 Analysis</div>
            <hr class="mx-2 my-2">
            <lds-y3-pie-chart [data]="eco7Data" *ngIf="eco7Data"></lds-y3-pie-chart>
          </div> -->
          <div class="pie-chart-container bar-container pt-2 mb-2">
            <div class="mx-4">Hourly Average Consumption</div>
            <hr class="mx-2 my-2">
            @if (hourlyAverage) {
              <lds-y3-bar-chart [data]="hourlyAverage"></lds-y3-bar-chart>
            }
          </div>
          @if (showLinkBtns) {
            <div class="btn-container">
              <button class="lds-btn"  (click)="changeRoute()">Switch Use</button>
              <button class="lds-btn active">Energy Use</button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
}
